import type { Component } from 'vue';

const buttonComponents = import.meta.glob<{ default: Component }>(
  '@/components/common/button/*.vue',
  { eager: true },
);

export const customButtons: Record<string, Component> = {};

for (const path in buttonComponents) {
  const name = path
    .split('/')
    .pop()
    ?.replace(/\.\w+$/, '');
  if (name) {
    customButtons[name] = buttonComponents[path].default;
  }
}
